import { render, staticRenderFns } from "./ControlValues.vue?vue&type=template&id=320a009d&scoped=true"
import script from "./ControlValues.vue?vue&type=script&lang=js"
export * from "./ControlValues.vue?vue&type=script&lang=js"
import style0 from "./ControlValues.vue?vue&type=style&index=0&id=320a009d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a009d",
  null
  
)

export default component.exports